import { render } from "./orderAndScreen.vue?vue&type=template&id=3ce5d015&scoped=true"
import script from "./orderAndScreen.vue?vue&type=script&lang=js"
export * from "./orderAndScreen.vue?vue&type=script&lang=js"

import "./orderAndScreen.vue?vue&type=style&index=0&id=3ce5d015&scoped=true&lang=scss"
import "./orderAndScreen.vue?vue&type=style&index=1&id=3ce5d015&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce5d015"]])

export default __exports__